import type { AttendanceMeResponse, AttendanceOverviewResponse } from '@krafta/shared-types';

import { buildMesUrl, mesHttp } from '@shared/api/mesClient';

export const attendanceApi = {
  async getMe() {
    const response = await mesHttp.get<AttendanceMeResponse>(buildMesUrl('/attendance/me'));
    return response.data;
  },

  async getOverview(params: { limit?: number; cursor?: string | null } = {}) {
    const response = await mesHttp.get<AttendanceOverviewResponse>(
      buildMesUrl('/attendance/overview', {
        limit: params.limit ? String(params.limit) : undefined,
        cursor: params.cursor ?? undefined
      })
    );
    return response.data;
  }
};
